// Only the Control survey is shown in User Guide
export const SURVEY_IDS = {
  QA: '441',
  PROD: '1190'
};
export const HAS_SEEN_USER_GUIDE_BEFORE_STORAGE_KEY = 'HAS_SEEN_USER_GUIDE_BEFORE';